export const overrides = theme => ({
  root: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,

    [`${theme.breakpoints.down('xs')}`]: {
      padding: theme.spacing(2),
    },
  },
})
